import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAccessUsersQuery } from "../api/Endpoints/Core/Security/Users";
import { ACCESS_RIGHTS } from "../constants/accessRights";
import { getCurrentUser, hasAccess } from "../helpers/session_helper";

const Navdata = () => {
  const history = useNavigate();
  const location = useLocation();

  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const shouldFetch = getCurrentUser()
  const { data, refetch } = useGetAccessUsersQuery({}, { skip: !shouldFetch });
  const accessRights = data?.returnData?.map(({
    permissionTypeId,
    allowRead,
    allowWrite,
    allowDelete
  }) => ({
    permissionTypeId,
    allowRead,
    allowWrite,
    allowDelete
  }));

  useEffect(() => {
    refetch();
  }, [location.pathname]);

  useEffect(() => {
    if (accessRights) {
      sessionStorage.setItem("accessRights", JSON.stringify(accessRights));
    }
  }, [accessRights]);

  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);

  const [isDashboard, setIsDashboard] = useState(false);

  const [isGlobo, setIsGlobo] = useState(false);

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }

    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }

    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "Globo") {
      setIsGlobo(false);
    }
  }, [
    history,

    iscurrentState,

    isApps,
    isAuth,
    isPages,
    isDashboard,

    isGlobo
  ]);

  const menuItems = [
    {
      label: "Globo Asiatico Enterprises Inc.",
      isHeader: true,
      color: "#0ab39c"
    },
    {
      id: "globo-dashboard",
      label: "Dashboard",
      icon: "ri-bar-chart-2-fill",
      link: "/globo/dashboard",
    },
    {
      id: "globo-patients",
      label: "Patient Masterlist",
      link: "/globo/patients",
      icon: "ri-team-fill",
      permissionTypeId: [ACCESS_RIGHTS.GLOBO_PATIENTS],
    },
    {
      id: "globo-doctors",
      label: "Healthcare Professionals",
      link: "/globo/doctors",
      icon: "ri-stethoscope-fill",
      permissionTypeId: [ACCESS_RIGHTS.GLOBO_STATICDATA_DOCTORS],
    },
    {
      id: "globo-hospitals",
      label: "Hospitals / Clinics",
      link: "/globo/settings/hospitals",
      icon: "ri-hospital-fill",
      permissionTypeId: [ACCESS_RIGHTS.GLOBO_STATICDATA_HOSPITALS],
    },
    {
      id: "globo-transactions-patient-enrollment-requests",
      label: "Patient Enrollments",
      link: "/globo/transactions/patient-enrollments",
      icon: "ri-user-heart-fill",
      permissionTypeId: [
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_VIEWER,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_REQUESTOR,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_APPROVER,
      ],
    },
    {
      id: "globo-transactions-doctor-enrollment-requests",
      label: "Physician Enrollments",
      link: "/globo/transactions/doctor-enrollments",
      icon: "ri-nurse-fill",
      permissionTypeId: [
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_VIEWER,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_REQUESTOR,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_APPROVER,
      ],
    },
    {
      id: "globo-transactions-prescription-requests",
      label: "Prescription Requests",
      link: "/globo/transactions/prescription-requests",
      icon: "ri-medicine-bottle-fill",
      permissionTypeId: [
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_VIEWER,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_APPROVER,
      ],
    },
    {
      id: "globo-transactions-orders",
      label: "Orders / Availments",
      link: "/globo/transactions/order-requests",
      icon: "ri-capsule-fill",
      permissionTypeId: [
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ORDERREQUESTS_VIEWER,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ORDERREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_ORDERREQUESTS_APPROVER,
      ],
    },
    {
      id: "globo-transactions-loarequests",
      label: "Letter of Availments",
      link: "/globo/transactions/loa-requests",
      icon: "ri-heart-pulse-fill",
      permissionTypeId: [
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_LOAREQUESTS_VIEWER,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_LOAREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.GLOBO_TRANSACTIONS_LOAREQUESTS_APPROVER,
      ],
    },
    {
      id: "globo-reports",
      label: "Reports",
      link: "/globo/reports",
      icon: "ri-stack-fill",
    },
    {
      id: "globo-settings",
      label: "Settings",
      link: "/globo/settings",
      icon: "ri-settings-2-fill",
      permissionTypeId: [
        ACCESS_RIGHTS.GLOBO_STATICDATA_DIAGNOSIS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_DROPOUTREASONS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_PATIENTSEGMENTS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_PRINCIPALS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_PRODUCTS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_PROGRAMS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_PURCHASINGACCOUNTS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_THERAPEUTICAREAS,
        ACCESS_RIGHTS.GLOBO_STATICDATA_UOMS,
      ],
    },

    {
      label: "Security",
      isHeader: true,
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_USERS,
        ACCESS_RIGHTS.CORE_SECURITY_ROLES,
        ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER,
      ]
    },
    {
      id: "Users",
      label: "Users",
      icon: "ri-admin-fill",
      link: "/security/users",
      click: function (e) {
        setIscurrentState("Users");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_USERS,
      ]
    },
    {
      id: "Roles",
      label: "Roles",
      icon: "ri-lock-unlock-fill",
      link: "/security/roles",
      click: function (e) {
        setIscurrentState("Roles");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_ROLES,
      ],
    },
    {
      id: "AuditLogs",
      label: "Audit Logs",
      icon: "ri-shield-flash-fill",
      link: "/security/auditLogs",
      click: function (e) {
        setIscurrentState("AuditLogs");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS,
      ],
    },
    {
      id: "AccessRequests",
      label: "Access Requests",
      icon: "ri-key-fill",
      link: "/security/accessrequests",
      click: function (e) {
        setIscurrentState("AccessRequests");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER,
      ],
    },

    {
      label: "Application",
      isHeader: true,
    },
    {
      id: "PrivacyPolicy",
      label: "Privacy Policy",
      icon: "ri-git-repository-private-fill",
      link: "/socials/privacy-policy",
      click: function (e) {
        setIscurrentState("PrivacyPolicy");
      },
    },
  ];

  const filterMenu = (items) => {
    return items
      .filter(item => hasAccess(item.permissionTypeId, accessRights))
      .map(item => {
        const newItem = { ...item };

        if (item.subItems) {
          newItem.subItems = filterMenu(item.subItems);
          if (newItem.subItems.length === 0) return null;
        }

        if (item.childItems) {
          newItem.childItems = filterMenu(item.childItems);
          if (newItem.childItems.length === 0) return null;
        }

        return newItem;
      })
      .filter(Boolean);
  };

  return <React.Fragment>{filterMenu(menuItems)}</React.Fragment>;
};
export default Navdata;
